import React from 'react'
import Images from '../assets/AllImages';
import { useTranslation } from 'react-i18next';

const OUTDOOR = () => {
  const { t } = useTranslation();

  return (
    <>
      <main>
        <div className="container-fluid bg-primary py-4">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 px-5">
              <h1 className="text-white fw-bold mb-4 responsive-heading">
                {t("outdoor.title")}
              </h1>
            </div>
            <div className="col-12 col-md-6 px-5 d-none d-sm-block text-end">
              <img src={Images.Vactor2} alt="Outdoor Vector" className='vector-img' />
            </div>
          </div>
        </div>
      </main>

      {/* Outdoor Banner Section */}
      <div className="container-fluid outdoor-banner text-center text-white d-flex align-items-center justify-content-center" style={{minHeight: '80vh'}}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              {/* <h2 className='fw-bold mb-4' style={{fontSize: '3.5rem', lineHeight: '1.2', textShadow: '2px 2px 8px rgba(0,0,0,0.7)'}}>
                Outdoor Olympic Pool & Kids Pool
              </h2> */}
              {/* <h4 className='fw-bold mb-4' style={{fontSize: '1.8rem', color: 'rgba(255,255,255,0.9)', textShadow: '1px 1px 4px rgba(0,0,0,0.6)'}}>
                A World-Class Aquatic Experience Under the Open Sky
              </h4> */}
              <h4 className="lead responsive-subtitle">
                {t("outdoor.bannerDesc")}
              </h4>
            </div>
          </div>
        </div>
      </div>

      {/* Olympic Pool Section */}
      <div className="container-fluid py-5 bg-light">
        <div className="row align-items-center">
          <div className="col-lg-6 px-0">
            <img src={Images.SwimmingCenter2} alt="Olympic Pool" className='w-100' style={{height: '500px', objectFit: 'cover'}} />
          </div>
          <div className="col-lg-6 p-5">
            <h3 className="text-primary fw-bold mb-4 responsive-heading">
              {t("outdoor.olympic.title")}
            </h3>
            {/* <p className='mb-4' style={{fontSize: '1.2rem', lineHeight: '1.7', color: '#666'}}>
              Our 50-meter Olympic pool meets all international standards and is perfect for professional training, competitions, and serious swimming sessions.
            </p> */}
            <ul className='list-unstyled mb-4' style={{fontSize: '1.1rem', lineHeight: '1.8'}}>
              <li className="mb-2">
                <span className='text-primary fw-bold'>{t("outdoor.common.lengthLabel")}</span> {t("outdoor.olympic.lengthValue")}
              </li>
              <li className="mb-2">
                <span className='text-primary fw-bold'>{t("outdoor.common.lanesLabel")}</span> {t("outdoor.olympic.lanesValue")}
              </li>
              <li className="mb-2">
                <span className='text-primary fw-bold'>{t("outdoor.common.depthLabel")}</span> {t("outdoor.olympic.depthValue")}
              </li>
            </ul>
            {/* <p style={{fontSize: '1.1rem', lineHeight: '1.7', color: '#666'}}>
              Equipped with state-of-the-art timing systems and spectator seating, this pool hosts regional and international competitions.
            </p> */}
          </div>
        </div>
      </div>

      {/* Kids Pool Section */}
      <div className="container-fluid py-5">
        <div className="row align-items-center">
          <div className="col-lg-6 p-5">
            <h3 className="text-primary fw-bold mb-4 responsive-heading">
              {t("outdoor.kids.title")}
            </h3>

            <ul className='list-unstyled mb-4' style={{fontSize: '1.1rem', lineHeight: '1.8'}}>
              <li className="mb-2">
                <span className='text-primary fw-bold'>{t("outdoor.common.lengthLabel")}</span> {t("outdoor.kids.lengthValue")}
              </li>
              <li className="mb-2">
                <span className='text-primary fw-bold'>{t("outdoor.kids.agesLabel")}</span> {t("outdoor.kids.agesValue")}
              </li>
              <li className="mb-2">
                <span className='text-primary fw-bold'>{t("outdoor.common.depthLabel")}</span> {t("outdoor.kids.depthValue")}
              </li>
            </ul>

          </div>
          <div className="col-lg-6 px-0">
            <img src={Images.SwimmingCenter3} alt="Kids Pool" className='w-100' style={{height: '500px', objectFit: 'cover'}} />
          </div>
        </div>
      </div>

      {/* Facilities Section (kept commented as in your code) */}
      {/* <div className="container-fluid py-5">
        ...
      </div> */}
    </>
  )
}

export default OUTDOOR;
